const $ = require('jquery');
const { Loader } = require('@googlemaps/js-api-loader');

let currentInfoWindow = null;
$(function () {
    if ($('#map').length > 0 ) {
        initializeMap();
    }
});

function initializeMap() {
    const loader = new Loader({
        apiKey: 'AIzaSyBGNhkd9OzZdTiUk0nNTHp-cOazP7JaWU0'
    });

    loader.load().then(async () => {
        const { Map } = await google.maps.importLibrary("maps");

        const map = new google.maps.Map(document.getElementById("map"), {
            zoom: 8,
            center: { lat: -34.397, lng: 150.644 }
        });

        const markers = addMarkers(map);
        fitBoundsToMarkers(map, markers);

        map.addListener('click', function (event) {
            if (!mapClickable) {
                event.stopPropagation();
            }
        });

        $('.pickupPlaceItem').on('click', function () {
            const locationId = $(this).data('location-id');
            updateMap(map, markers, locationId);
        });

        $('input[name="location"]').on('change', function () {
            const locationId = $(this).val();

            $('.pickupPlaceItem').removeClass('active');
            $(`.pickupPlaceItem[data-location-id="${locationId}"]`).addClass('active');

            const pickupDiffInMinutes = parseInt($(this).data('location-pickup-diff'), 10);

            $('#pickup_time option').each(function () {
                const option = $(this);
                const time = option.data('original-value');

                if (/^\d{2}:\d{2}$/.test(time)) {
                    const [hours, minutes] = time.split(':').map(Number);
                    const date = new Date();
                    date.setHours(hours);
                    date.setMinutes(minutes + pickupDiffInMinutes);

                    const newHours = date.getHours().toString().padStart(2, '0');
                    const newMinutes = date.getMinutes().toString().padStart(2, '0');
                    const newTime = `${newHours}:${newMinutes}`;

                    option.val(newTime);
                    option.text(newTime);
                }
            });
        });
    });
}

function addMarkers(map) {
    const registeredMarkers = [];
    let originalMapPosition;
    markers.forEach(function (markerInfo) {
        const marker = new google.maps.Marker({
            position: { lat: markerInfo.lat, lng: markerInfo.lng },
            map: map
        });

        const infoWindow = createInfoWindow(markerInfo);
        attachInfoWindow(marker, map, infoWindow, markerInfo.id);

        $(document).on('click', '.info-window-show-photo', function () {
            const infoWindowImage = $(this).closest('.info-window-image').find('.infoWindowImage');
            if (infoWindowImage.hasClass('d-none')) {
                infoWindowImage.removeClass('d-none');
                $(this).html('<i class="fa fa-eye-slash" aria-hidden="true"></i>Hide location photo');
                originalMapPosition = map.getCenter();
                const imageHeight = infoWindowImage.height();
                map.panBy(0, -imageHeight);
            } else {
                infoWindowImage.addClass('d-none');
                $(this).html('<i class="fa fa-eye" aria-hidden="true"></i>Show location photo');
                if (originalMapPosition) {
                    map.panTo(originalMapPosition);
                }
            }
        });

        registeredMarkers.push({ id: markerInfo.id, marker: marker, infoWindow: infoWindow });
    });
    return registeredMarkers;
}

function createInfoWindow(markerInfo) {
    const infoDescription = markerInfo.description.replace(/,/g, ',<br>');
    const contentString = `
        <div class="info-window-content">
            <div class="info-window-description">${infoDescription}</div>
            <div class="info-window-image">
                <span class="info-window-show-photo"><i class="fa fa-eye" aria-hidden="true"></i>Show location photo</span>
                <img class="d-none infoWindowImage" src="${markerInfo.imageUrl}">
            </div>
        </div>`;
    return new google.maps.InfoWindow({ content: contentString });
}

function attachInfoWindow(marker, map, infoWindow, id) {
    marker.addListener('click', function () {
        closeCurrentInfoWindow();
        infoWindow.open(map, marker);
        currentInfoWindow = infoWindow;
        mapClickable = false;
        $(`#location_${id}`).prop('checked', true).change();
    });
}

function closeCurrentInfoWindow() {
    if (currentInfoWindow !== null) {
        currentInfoWindow.close();
    }
}

function fitBoundsToMarkers(map, markers) {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(function (marker) {
        bounds.extend(marker.marker.getPosition());
    });
    map.fitBounds(bounds);
}

function updateMap(map, markers, locationId) {
    closeCurrentInfoWindow();
    const selectedMarker = markers.find(function (marker) {
        return marker.id === locationId;
    });

    map.setCenter(selectedMarker.marker.getPosition());
    map.setZoom(15);
    selectedMarker.infoWindow.open(map, selectedMarker.marker);
    currentInfoWindow = selectedMarker.infoWindow;
}

